export class GLAdjustment {
  constructor(
    public glCode: string,
    public glPolicyCode: string,
    public amount: number) {}
}



// WEBPACK FOOTER //
// ./src/app/models/glAdjustment.model.ts